import {
  DOCUMENTOS_TIPOS,
  OTRO_NO_LISTADO,
  etiquetaTipoDocumento,
} from "./captacionDocumentosTipos";

/**
 * Valor solo UI en el desplegable principal: abre el desplegable secundario con el resto del catálogo.
 * No persistir en BD.
 */
export const META_OTROS_FICHA_PROP = "__meta_otros_ficha_prop__";

/**
 * Tipos frecuentes en la ficha propiedad — Documentación (etiquetas de negocio).
 * Se ordenan alfabéticamente por etiqueta (es).
 */
const TIPOS_RAPIDOS_FICHA_PROP_RAW = [
  { codigo: "dni_nif_propietario", etiqueta: "DNI Propietari@" },
  { codigo: "nota_encargo", etiqueta: "Encargo de Venta" },
  { codigo: "escritura_compraventa", etiqueta: "Escritura propiedad" },
  { codigo: "contrato_exclusiva", etiqueta: "Exclusiva de Venta" },
  { codigo: "contrato_alquiler", etiqueta: "Contrato de Alquiler" },
  { codigo: "contrato_suministro_agua", etiqueta: "Factura Agua" },
  { codigo: "contrato_suministro_luz", etiqueta: "Factura luz" },
  { codigo: "ficha_captacion", etiqueta: "Ficha de Captación" },
  { codigo: "cert_grafica_catastral", etiqueta: "Ficha gráfica catastral" },
  { codigo: "ibi_recibo", etiqueta: "IBI" },
  { codigo: "inventario_muebles", etiqueta: "Inventario muebles" },
  { codigo: "nota_simple_informativa", etiqueta: "Nota Simple" },
];

export const TIPOS_RAPIDOS_FICHA_PROP = [...TIPOS_RAPIDOS_FICHA_PROP_RAW].sort((a, b) =>
  a.etiqueta.localeCompare(b.etiqueta, "es", { sensitivity: "base" })
);

export const CODIGOS_TIPOS_RAPIDOS_FICHA_SET = new Set(TIPOS_RAPIDOS_FICHA_PROP.map((t) => t.codigo));

/** ¿El código debe mostrarse en el desplegable principal (no en «Otros»)? */
export function esTipoRapidoFichaProp(codigo) {
  return codigo != null && CODIGOS_TIPOS_RAPIDOS_FICHA_SET.has(String(codigo));
}

/** Resto del catálogo + «Otro no listado», orden alfabético por etiqueta (es). */
export function getTiposRestoFichaPropOrdenados() {
  const resto = DOCUMENTOS_TIPOS.filter((t) => !CODIGOS_TIPOS_RAPIDOS_FICHA_SET.has(t.codigo)).map((t) => ({
    codigo: t.codigo,
    etiqueta: t.etiqueta,
  }));
  resto.push({
    codigo: OTRO_NO_LISTADO,
    etiqueta: etiquetaTipoDocumento(OTRO_NO_LISTADO) || "Otro (no está en la lista)",
  });
  resto.sort((a, b) => a.etiqueta.localeCompare(b.etiqueta, "es", { sensitivity: "base" }));
  return resto;
}
